export default __webpack_public_path__ + "static/media/isotipo.5f3135df.svg";